import Icon from "@ant-design/icons";

const TimesheetIconSVG = (props) => (
  <svg
    width={props?.width || "20"}
    height={props?.height}
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M10.0007 18.4583C5.91013 18.4583 2.58398 15.1322 2.58398 11.0417C2.58398 6.95114 5.91013 3.625 10.0007 3.625C14.0912 3.625 17.4173 6.95114 17.4173 11.0417C17.4173 15.1322 14.0912 18.4583 10.0007 18.4583ZM10.0007 3.875C6.04951 3.875 2.83398 7.09052 2.83398 11.0417C2.83398 14.9928 6.04951 18.2083 10.0007 18.2083C13.9518 18.2083 17.1673 14.9928 17.1673 11.0417C17.1673 7.09052 13.9518 3.875 10.0007 3.875Z"
      fill={props?.color}
      stroke={props?.color}
    />
    <path
      d="M10 10.9583C9.96985 10.9583 9.93857 10.946 9.91293 10.9204C9.88728 10.8947 9.875 10.8634 9.875 10.8333V6.66663C9.875 6.63648 9.88728 6.6052 9.91293 6.57955C9.93857 6.55391 9.96985 6.54163 10 6.54163C10.0301 6.54163 10.0614 6.55391 10.0871 6.57955C10.1127 6.6052 10.125 6.63648 10.125 6.66663V10.8333C10.125 10.8634 10.1127 10.8947 10.0871 10.9204C10.0614 10.946 10.0301 10.9583 10 10.9583Z"
      fill={props?.color}
      stroke={props?.color}
    />
    <path
      d="M12.5 1.79163H7.5C7.46985 1.79163 7.43857 1.77934 7.41293 1.7537C7.38728 1.72805 7.375 1.69677 7.375 1.66663C7.375 1.63648 7.38728 1.6052 7.41293 1.57955C7.43857 1.55391 7.46985 1.54163 7.5 1.54163H12.5C12.5301 1.54163 12.5614 1.55391 12.5871 1.57955C12.6127 1.6052 12.625 1.63648 12.625 1.66663C12.625 1.69677 12.6127 1.72805 12.5871 1.7537C12.5614 1.77934 12.5301 1.79163 12.5 1.79163Z"
      fill={props?.color}
      stroke={props?.color}
    />
  </svg>
);
const TimesheetIcon = (props) => (
  <Icon component={() => TimesheetIconSVG(props)} {...props} />
);

export default TimesheetIcon;
